export default function SpecialOffers() {
  const offers = [
    {
      title: '$99 AC Tune Up Special',
      description: 'Complete air conditioning system inspection and tune up. Keep your AC running efficiently all summer long.',
      features: ['Complete System Inspection', 'Filter Replacement', 'Refrigerant Check', 'Performance Testing'],
      discount: 'Save $50',
      image: 'https://public.readdy.ai/ai/img_res/08f0779479ba4ff564fe42a7128c3b54.jpg'
    },
    {
      title: 'New Customer Discount',
      description: 'First time customers receive 15% off any service. Experience the Voltis difference with this exclusive offer.',
      features: ['Valid on All Services', 'No Hidden Fees', 'Upfront Pricing', 'Satisfaction Guaranteed'],
      discount: '15% OFF',
      image: 'https://readdy.ai/api/search-image?query=Happy%20Florida%20homeowner%20shaking%20hands%20with%20professional%20Voltis%20technician%20at%20front%20door%2C%20modern%20home%20entrance%2C%20friendly%20service%20interaction%2C%20bright%20sunny%20day%2C%20welcoming%20atmosphere%20showcasing%20new%20customer%20experience&width=500&height=350&seq=offer-new-002&orientation=landscape'
    },
    {
      title: 'Annual Maintenance Plan',
      description: 'Protect your investment with our comprehensive maintenance plan. Priority service and exclusive discounts included.',
      features: ['2 Annual Visits', 'Priority Scheduling', '15% Off Repairs', 'No Overtime Charges'],
      discount: 'Best Value',
      image: 'https://readdy.ai/api/search-image?query=Professional%20technician%20performing%20routine%20maintenance%20on%20HVAC%20system%20in%20Florida%20home%2C%20organized%20service%20checklist%2C%20clean%20mechanical%20room%2C%20quality%20maintenance%20service%20atmosphere%20with%20tools%20and%20equipment&width=500&height=350&seq=offer-maint-003&orientation=landscape'
    }
  ];

  return (
    <section id="offers" className="py-20 bg-gradient-to-b from-white to-[#F8F9FC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-[#B22234]/10 text-[#B22234] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            LIMITED TIME OFFERS
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1B3A6B] mb-4">
            Special Offers &amp; Savings
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Take advantage of our current promotions and save on quality home services. These exclusive offers won't last long!
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {offers.map((offer, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={offer.image} 
                  alt={`${offer.title} - Voltis Florida Special Offer`}
                  title={offer.title}
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute top-4 right-4 bg-[#B22234] text-white px-4 py-2 rounded-lg font-bold text-sm shadow-lg">
                  {offer.discount}
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-2xl font-bold text-[#1B3A6B] mb-3">{offer.title}</h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">{offer.description}</p>
                
                <ul className="space-y-2 mb-6">
                  {offer.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-[#B22234] mr-2 text-lg"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <a href="#contact" className="block w-full bg-[#B22234] text-white text-center px-6 py-3 rounded-lg text-sm font-semibold hover:bg-[#8B1A29] transition-colors whitespace-nowrap cursor-pointer">
                  Claim This Offer
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-[#1B3A6B] to-[#2A4F8F] rounded-2xl p-8 md:p-12 text-center shadow-xl">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Ready to Save on Your Next Service?
          </h3>
          <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
            Contact us today to learn more about our current promotions and find the perfect solution for your home service needs.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="#contact" className="bg-white text-[#1B3A6B] px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all shadow-lg hover:scale-105 whitespace-nowrap cursor-pointer">
              Schedule Service
            </a>
            <a href="tel:+18005551234" className="bg-[#B22234] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#8B1A29] transition-all shadow-lg hover:scale-105 flex items-center whitespace-nowrap cursor-pointer">
              <i className="ri-phone-fill mr-2"></i>
              (800) 555-1234
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
